// // GoogleLoginButton.jsx
// import React from 'react';
// import { GoogleLogin, useGoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
// import { getBaseUrl } from '../utils/helpers.js';
// import Cookies from 'js-cookie';

// const GoogleLoginButton = ({ clientId, setLoginSuccess }) => {
//     const baseUrl = getBaseUrl()
//     const googleLogin = useGoogleLogin({
//         onSuccess: async (response) => {
//             if (response.access_token) {
//                 try {
//                     const res = await fetch(`${baseUrl}/api/auth/sign-in`, {
//                         method: 'POST',
//                         headers: {
//                             'Content-Type': 'application/json',
//                             'Authorization': response.access_token,
//                         },
//                         body: JSON.stringify({ provider: 'GOOGLE' }),
//                     });

//                     const data = await res.json();
//                     Cookies.set('token', data.access_token, { expires: 7 });
//                     localStorage.setItem('userEmail', data.email);

//                     // Redireciona para o dashboard
//                     window.location.href = '/dashboard';
//                     setLoginSuccess(true);
//                 } catch (err) {
//                     console.error('Erro ao fazer login:', err);
//                 }
//             }
//         },
//         onError: (error) => {
//             console.log('Login Failed:', error);
//         },
//     });

//     return (
//         <button
//             onClick={() => googleLogin()}
//             style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 backgroundColor: '#ffffff',
//                 color: '#757575',
//                 border: '1px solid #dadce0',
//                 borderRadius: '4px',
//                 padding: '10px 16px',
//                 fontSize: '14px',
//                 fontWeight: 500,
//                 fontFamily: 'Roboto, sans-serif',
//                 cursor: 'pointer',
//                 transition: 'background-color 0.3s, box-shadow 0.3s',
//                 minWidth: '240px',
//                 width: '100%',
//             }}
//         >
//             <svg
//                 className="google-svg"
//                 style={{ marginRight: '15px' }}
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="24"
//                 height="25"
//                 preserveAspectRatio="xMidYMid"
//                 viewBox="0 0 256 262"
//             >
//                 <path fill="#4285F4" d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" />
//                 <path fill="#34A853" d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" />
//                 <path fill="#FBBC05" d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782" />
//                 <path fill="#EB4335" d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" />
//             </svg>
//             Sign in with Google
//         </button>
//     );
// };

// // Componente wrapper para fornecer o clientId
// export const GoogleLoginProvider = ({ clientId, children }) => {
//     return <GoogleOAuthProvider clientId={clientId}>{children}</GoogleOAuthProvider>;
// };

// export default GoogleLoginButton;




import React from 'react';
import { useGoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useNavigate, useLocation } from 'react-router-dom';
import { getBaseUrl } from '../utils/helpers.js';
import Cookies from 'js-cookie';
import { useAuth } from '../contexts/AuthContext.tsx';

const GoogleLoginButton = ({ clientId, setLoginSuccess }) => {
    const baseUrl = getBaseUrl();
    const navigate = useNavigate();
    const location = useLocation();
    const { login: globalLogin } = useAuth();

    // Função para obter redirecionamento
    const getRedirectPath = () => {
        const state = location.state;

        if (state?.from) {
            if (typeof state.from === 'object' && state.from.pathname) {
                return state.from.pathname;
            }
            if (typeof state.from === 'string') {
                return state.from;
            }
        }

        return '/dashboard';
    };

    const googleLogin = useGoogleLogin({
        onSuccess: async (response) => {
            if (response.access_token) {
                try {
                    console.log('🔍 Google token received, sending to backend...');

                    // Formato CORRETO baseado no seu código original
                    const res = await fetch(`${baseUrl}/api/auth/sign-in`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': response.access_token,
                        },
                        body: JSON.stringify({ provider: 'GOOGLE' }),
                    });

                    console.log('📥 Response status:', res.status);

                    // Verificar se a resposta é JSON
                    const contentType = res.headers.get('content-type');
                    let data;

                    if (contentType && contentType.includes('application/json')) {
                        data = await res.json();
                    } else {
                        const text = await res.text();
                        console.error('❌ Non-JSON response:', text.substring(0, 200));
                        throw new Error('Server returned invalid response');
                    }

                    console.log('📥 Backend response:', data);

                    if (!res.ok) {
                        // Tratamento específico para erros comuns
                        if (res.status === 401) {
                            throw new Error('Google token invalid or expired');
                        }
                        if (res.status === 400) {
                            throw new Error(data.message || 'Invalid request format');
                        }
                        throw new Error(data.message || `Authentication failed: ${res.status}`);
                    }

                    // Verificar se tem token na resposta
                    if (!data.access_token && !data.token) {
                        console.error('❌ No token in response:', data);
                        throw new Error('No authentication token received from server');
                    }

                    // 🔥 ADICIONADO: Usar o AuthContext para atualizar estado global
                    const appToken = data.access_token || data.token;
                    const userEmail = data.email;

                    if (appToken) {
                        // 1. Atualizar AuthContext (ESTADO GLOBAL)
                        globalLogin(appToken, userEmail || '');

                        // 2. Manter compatibilidade (Cookies e localStorage)
                        Cookies.set('token', appToken, { expires: 7 });
                        if (userEmail) {
                            localStorage.setItem('userEmail', userEmail);
                        }

                        // 3. Disparar evento para sincronizar componentes
                        window.dispatchEvent(new Event('authStateChanged'));

                        console.log('✅ Google login successful, state updated');
                    }

                    // 🔥 ADICIONADO: Redirecionamento inteligente (não apenas dashboard)
                    const redirectTo = getRedirectPath();
                    console.log('📍 Redirecting to:', redirectTo);

                    // Pequeno delay para garantir que o estado foi atualizado
                    setTimeout(() => {
                        navigate(redirectTo, { replace: true });
                    }, 100);

                    if (setLoginSuccess) {
                        setLoginSuccess(true);
                    }
                } catch (err) {
                    console.error('❌ Google login error:', err);

                    // 🔥 ADICIONADO: Mensagens mais específicas
                    let errorMessage = 'Google login failed. ';

                    if (err.message.includes('token invalid')) {
                        errorMessage += 'The Google token is invalid or expired.';
                    } else if (err.message.includes('Invalid request')) {
                        errorMessage += 'Server rejected the request format.';
                    } else if (err.message.includes('No authentication token')) {
                        errorMessage += 'Server did not return authentication token.';
                    } else {
                        errorMessage += err.message;
                    }

                    alert(errorMessage);
                }
            } else {
                console.error('❌ No access token from Google');
                alert('Google login failed: No access token received.');
            }
        },
        onError: (error) => {
            console.log('❌ Google login failed:', error);

            // 🔥 ADICIONADO: Ignorar warnings de Cross-Origin-Opener-Policy
            if (error.toString().includes('Cross-Origin-Opener-Policy')) {
                console.log('⚠️ Google popup policy warning (safe to ignore)');
                return;
            }

            if (error.error === 'popup_closed_by_user') {
                console.log('ℹ️ User closed the Google login popup');
                return;
            }

            alert('Google login failed. Please try again or use email/password.');
        },
    });

    return (
        <button
            onClick={() => googleLogin()}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#ffffff',
                color: '#757575',
                border: '1px solid #dadce0',
                borderRadius: '4px',
                padding: '10px 16px',
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: 'Roboto, sans-serif',
                cursor: 'pointer',
                transition: 'background-color 0.3s, box-shadow 0.3s',
                minWidth: '240px',
                width: '100%',
                marginBottom: '1rem',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 1px 3px 1px rgba(66, 64, 67, 0.15)';
                e.currentTarget.style.backgroundColor = '#f8f9fa';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.backgroundColor = '#ffffff';
            }}
        >
            <svg
                className="google-svg"
                style={{ marginRight: '15px' }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                preserveAspectRatio="xMidYMid"
                viewBox="0 0 256 262"
            >
                <path fill="#4285F4" d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" />
                <path fill="#34A853" d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" />
                <path fill="#FBBC05" d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782" />
                <path fill="#EB4335" d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" />
            </svg>
            Sign in with Google
        </button>
    );
};

// Componente wrapper para fornecer o clientId
export const GoogleLoginProvider = ({ clientId, children }) => {
    return <GoogleOAuthProvider clientId={clientId}>{children}</GoogleOAuthProvider>;
};

export default GoogleLoginButton;